function getLocalesByRegion(localesObj, region) {
  return Object.values(localesObj)
    .filter(l => l.region === region)
    .map(l => l.locale);
}

module.exports = getLocalesByRegion;
